import React, { createContext, useContext, useState, useEffect } from 'react'
import { zh, en } from './locales'

const translations = { zh, en }

const LanguageContext = createContext()

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language')
    return saved || 'zh'
  })

  useEffect(() => {
    localStorage.setItem('language', language)
    document.documentElement.lang = language
  }, [language])

  const t = (key) => {
    const keys = key.split('.')
    let value = translations[language]
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k]
      } else {
        console.warn(`Translation missing for key: ${key}`)
        return key
      }
    }
    
    return value || key
  }

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'zh' ? 'en' : 'zh')
  }

  const changeLanguage = (lang) => {
    if (lang === 'zh' || lang === 'en') {
      setLanguage(lang)
    }
  }

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage: changeLanguage,
      toggleLanguage,
      t 
    }}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider')
  }
  return context
}

export default LanguageContext
